var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['root', _vm.getActiveTheme]},[_c('router-view'),_c('notifications',{attrs:{"position":"bottom right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }